import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { validationRules } from "utils/constants";
import AuthContext from "../context/AuthContext";
import Loader from "../layout/Loader";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import jwt_decode from "jwt-decode";
import Authenticator from "components/mfa/Authenticator";
import MFASetupModal from "components/mfa/MFASetupModal";
import axios from "axios";
import useToastContext from "hooks/useToastContext";
import { getDeviceId } from "utils/deviceId";
import Swal from "sweetalert2";

function Login() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  // console.log('searchparams', search?.get('token'))

  const { t } = useTranslation();
  const [icon, setIcon] = useState(true);
  const notification = useToastContext();

  const navigate = useNavigate();
  let {
    loginUser,
    user,
    setUser,
    mfaChallenge,
    completeMfaLogin,
    completeMfaSetupLogin,
    finishMfaSetupLogin,
    cancelMfaChallenge,
  } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onBlur", shouldFocusError: true, defaultValues: {} });
  const [rememberMe, setRememberMe] = useState(
    sessionStorage.getItem("rememberMe") === "true" ? true : false,
  );
  const [currentAddress, setCurrentAddress] = useState("");
  const loginGpsRef = useRef({ latitude: null, longitude: null, address: "" });

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        loginGpsRef.current.latitude = latitude;
        loginGpsRef.current.longitude = longitude;
        try {
          const response = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCyfi1GcGsUisGcHoaRNxTTq2VCoEXb1h8`,
          );
          if (response.data.results.length > 0) {
            // PREVIOUS: results[8] is city only (Noida, Uttar Pradesh 201309), not current pin
            // const address = (
            //   response.data.results[8] || response.data.results[0]
            // ).formatted_address;
            const address = (
              response.data.results[0] || response.data.results[8]
            ).formatted_address;
            setCurrentAddress(address);
            loginGpsRef.current.address = address;
          } else {
            console.error("No address found for the given coordinates.");
          }
        } catch (error) {
          console.error("Error fetching address:", error);
        }
      });
    } else {
      console.error("Geolocation is not supported by your browser.");
    }
  };

  const handleRememberMe = (e) => {
    sessionStorage.setItem("rememberMe", e.target.checked);
    setRememberMe(e.target.checked);
  };

  useEffect(() => {
    if (rememberMe) {
      reset({
        email: sessionStorage.getItem("email"),
        password: sessionStorage.getItem("password"),
      });
    }
  }, []);

  const waitForLoginGps = () =>
  new Promise((resolve) => {
    if (loginGpsRef.current.latitude != null && loginGpsRef.current.address) {
      resolve(loginGpsRef.current);
      return;
    }
    getCurrentLocation();
    const started = Date.now();
    const timer = setInterval(() => {
      if (
        (loginGpsRef.current.latitude != null && loginGpsRef.current.address) ||
        Date.now() - started > 6000
      ) {
        clearInterval(timer);
        resolve(loginGpsRef.current);
      }
    }, 200);
  });

  const onSubmit = async (data) => {
    if (rememberMe) {
      sessionStorage.setItem("email", data.email);
      sessionStorage.setItem("password", data.password);
    } else {
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("password");
    }
    const gps = await waitForLoginGps();
    let loginIp = sessionStorage.getItem("loginIp") || "";
    if (!loginIp) {
      try {
        const ipRes = await fetch("https://api.ipify.org?format=json");
        loginIp = String((await ipRes.json())?.ip || "").trim();
        if (loginIp) sessionStorage.setItem("loginIp", loginIp);
      } catch (err) {
        loginIp = "";
      }
    }
    const loginLocation = {
      latitude: gps.latitude,
      longitude: gps.longitude,
      loginAddress: gps.address || currentAddress,
      loginIp,
    };
    sessionStorage.setItem("loginGps", JSON.stringify(loginLocation));
    loginUser({
      ...data,
      deviceId: sessionStorage.getItem("fcm"),
      deviceType: "web",
      deviceToken: sessionStorage.getItem("fcm"),
      ...loginLocation,
      fraudDeviceId: getDeviceId(), // FRAUD: not the same as deviceId (that one is the push token)
    });
  };

  useEffect(() => {
    getCurrentLocation();
  }, []);

  useEffect(() => {
    const msg = sessionStorage.getItem("ipSessionMessage");
    if (msg) {
      sessionStorage.removeItem("ipSessionMessage");
      notification.error(msg);
    }
  }, []);
  useEffect(() => {
    if (user !== null && sessionStorage.getItem("token")) {
      if (user?.isTemporaryPassword === true) {
        Swal.fire({
          icon: "warning",
          title: t("CHANGE_PASSWORD_TITLE"),
          text: t("CHANGE_PASSWORD_FIRST_LOGIN_MSG"),
          confirmButtonText: t("GO_TO_SETTINGS"),
          cancelButtonText: t("CANCEL"),
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) navigate("/change-password");
          else navigate("/dashboard");
        });
      } else {
        navigate("/dashboard");
      }
    }
  }, [user]);
  useEffect(() => {
    const token = search?.get("token");
    if (!isEmpty(token)) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("refresh_token", token);
      const decodeToken = jwt_decode(token);
      console.log("decodeToken", decodeToken);
      setUser(decodeToken);
    }
  }, [search]);

  function changeIcon() {
    setIcon(!icon);
  }

  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };

  return (
    <div className="bg-gradient-to-r from-gradblue to-LightBlue h-full">
      <Loader />
      <div className="p-4">
        <div className="login-form bg-white max-w-lg m-auto mt-10 sm:mt-16 md:mt-28 rounded-[20px]">
          <form
            className="sm:py-12 sm:px-11 py-8 px-7"
            onSubmit={handleSubmit(onSubmit)}
            method="post"
          >
            <img src="./images/empivo.png" alt="" className="m-auto py-2" />
            <h1 className="text-center text-[40px] font-bold">
              {t("LOGIN_LETS_START")}!
            </h1>
            <h2 className="text-center text-lg text-[#A5A5A5] sm:mb-12 mb-6">
              {t("LOGIN_ONLY_FEW_MINUTES")}
            </h2>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="text"
                id="email"
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                onKeyDown={(e) => preventSpace(e)}
                // autoFocus
                {...register("email", {
                  required: "Please enter email ID.",
                  pattern: {
                    value: validationRules.email,
                    message:
                      "Please enter valid email ID as: example@domain.com.",
                  },
                })}
              />

              <label
                htmlFor="username"
                className="peer-focus:font-normal absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                {t("O_EMAIL_ID")}
                <span className="text-red-500">*</span>
              </label>
              <ErrorMessage message={errors?.email?.message} />
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type={icon ? "password" : "text"}
                placeholder=" "
                name="password"
                id="password"
                maxLength={40}
                className="bg-transparent border-2 block py-4 px-3 w-full text-sm text-gray-900 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                autoComplete="new-password"
                {...register("password", {
                  required: "Please enter password.",
                  pattern: {
                    value: validationRules.password,
                    message:
                      "Password must contain lowercase,uppercase characters, numbers, special character and must be 8 character long.",
                  },
                })}
              />
              <label
                className="duration-300 peer-focus:font-normal absolute text-sm text-gray-500 dark:text-gray-400 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                htmlFor="password"
              >
                {t("O_PASSWORD")}
                <span className="text-red-500">*</span>
              </label>
              {icon ? (
                <span
                  onClick={() => changeIcon()}
                  className="absolute password_view cursor-pointer top-[18px] right-[20px]"
                >
                  <AiFillEyeInvisible />
                </span>
              ) : (
                <span
                  className="top-[18px] password_view absolute right-[20px]"
                  onClick={() => changeIcon()}
                >
                  <AiFillEye />
                </span>
              )}
              <ErrorMessage message={errors?.password?.message} />
            </div>
            <div className="flex items-start mb-8">
              <div className="flex items-center h-5">
                <div>
                  <input
                    id="remember"
                    type="checkbox"
                    checked={rememberMe ? true : false}
                    className="w-4 h-4 bg-gray-50 rounded border border-[#DFDFDF]  focus:ring-3 focus:ring-[#DFDFDF] dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-[#DFDFDF] dark:ring-offset-gray-800"
                    onChange={(e) => handleRememberMe(e)}
                  />
                </div>
                <label
                  htmlFor="remember"
                  className="ml-2 text-sm text-black dark:text-gray-300"
                >
                  {t("LOGIN_REMEMBER_ME")}
                </label>
              </div>
              <Link
                to="/forgot-password"
                className="ml-auto text-[#6236FF] hover:text-[#9D36FF] hover:underline text-sm font-medium"
              >
                {t("LOGIN_FORGOT_PASSWORD")}?
              </Link>
            </div>
            <div className="text-center mt-8">
              <OButton label={<>{t("LOGIN_LOGIN")}</>} type="submit" />
            </div>
          </form>
        </div>
      </div>
      <Authenticator
        isOpen={!!mfaChallenge && !mfaChallenge.setup}
        onClose={cancelMfaChallenge}
        onVerify={(code, opts) => completeMfaLogin(code, opts)}
        onSuccess={() => {}} // completeMfaLogin already navigates on success
        title="Two-factor verification"
        description="Enter the 6-digit code from your authenticator app."
        allowRecoveryCode
      />
      <MFASetupModal
        isOpen={!!mfaChallenge?.setup}
        onClose={cancelMfaChallenge}
        onEnabled={finishMfaSetupLogin}
        loginSetup={
          mfaChallenge?.setup
            ? {
                qrCodeDataUrl: mfaChallenge.qrCodeDataUrl,
                manualEntryKey: mfaChallenge.manualEntryKey,
              }
            : null
        }
        onLoginConfirm={completeMfaSetupLogin}
      />
    </div>
  );
}

export default Login;
